import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import MarketingLayout from '../marketing/MarketingLayout'
import Seo from '../marketing/Seo'
import StoreBadges from '../marketing/StoreBadges'
import BLOG_POSTS from './blogPosts'
import '../AppLandingPage.css'
import '../marketing/Marketing.css'

/** /blog — index of all wedding planning articles, newest first. */
export default function BlogIndex() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const posts = [...BLOG_POSTS].reverse()

    return (
        <MarketingLayout>
            <Seo
                title="Wedding Planning Tips & Guides UK | First Dance Blog"
                description="Practical wedding planning advice for UK couples: what to do when you get engaged, planning timelines, guest list tips and the best wedding planning apps compared."
                path="/blog"
            />

            <div className="marketing-page">
                <div className="marketing-hero">
                    <p className="marketing-breadcrumb">
                        <Link to="/">Home</Link> &rsaquo; Blog
                    </p>
                    <h1>Wedding planning tips &amp; guides</h1>
                    <p className="marketing-hero-motto">The fun way to plan your wedding day</p>
                    <p className="marketing-hero-intro">
                        Practical, UK-focused advice for every stage of your planning journey — from the
                        first “we’re engaged!” to the last dance.
                    </p>
                </div>
                <div className="hero-divider" />

                <section className="marketing-section">
                    <div className="marketing-container">
                        <div className="features-index-grid">
                            {posts.map((post) => (
                                <Link
                                    key={post.slug}
                                    to={`/blog/${post.slug}`}
                                    className="feature-index-card"
                                >
                                    <img
                                        src={post.image}
                                        alt={post.imageAlt}
                                        className="feature-index-card-image"
                                    />
                                    <div className="feature-index-card-body">
                                        <span className="blog-card-meta">
                                            {post.dateLabel} &middot; {post.readTime}
                                        </span>
                                        <h3>{post.title}</h3>
                                        <p>{post.excerpt}</p>
                                        <span className="feature-index-card-cta">Read the article</span>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </section>

                <div className="marketing-cta-band">
                    <h2>Ready to put the tips into practice?</h2>
                    <p>Download First Dance free and start planning the fun way</p>
                    <StoreBadges />
                </div>
            </div>
        </MarketingLayout>
    )
}
